import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import useEndpoints from './../api/useEndpoints';
import Storages from './../helper/storages';
import errorHandler from './../api/errorHandler';

function sleep(delay = 0) {
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
}

export default function Address(props) {
    const endpoints = useEndpoints();

    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);



    React.useEffect(() => {
        updateList('')
    }, [])


    var timer;
    var onTextChange = (e) => {

        props.onType(e)

        setLoading(true);
        if (e.target.value == '') {
            props.onClose()
        }
        if (timer)
            clearTimeout(timer)
        timer = setTimeout(() => {
            console.log('typeEnd')
            updateList(e.target.value)
        }, 2000)
    }


    var updateList = (searchTerm) => {

        axios.get(endpoints.destAddress,
            {
                params:
                {
                    searchTerm: searchTerm,
                },
                headers:
                {
                    'x-auth-token': Storages.getUserToken()
                }
            }).then((res) => {
                setLoading(false);
                setOptions(res.data.result);

            }).catch((e) => {
                console.log(e)
            })
    }


    return (
        <Autocomplete
            className='col-12'
            open={open}
            freeSolo
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            getOptionLabel={(option) => option.code + '-' + option.DestName}
            onKeyDown={props.onKeyDown}

            options={options}
            loading={loading}

            onChange={(e) => {
                 if (e.target.nodeName == 'LI') {

                    options.map((option, index) => {

                        if (e.target.innerText) {

                            if (e.target.innerText.split('-')[1] == option.DestName) {

                                var event = {
                                    target: {
                                        name: props.name,
                                        value: option,
                                        valueStr: option.DestName
                                    }
                                }
                                props.onChange(event)
                            }
                        }

                    })

                } else if(e.target.nodeName == 'INPUT'){
                    setTimeout(() => {
                        options.map((option, index) => {

                            if (e.target.value) {

                                if (e.target.value.split('-')[1] == option.DestName) {

                                    var event = {
                                        target: {
                                            name: props.name,
                                            value: option,
                                            valueStr: option.DestName
                                        }
                                    }
                                    props.onChange(event)
                                }
                            }

                        })
                    }, 300)

                }else{
                    props.onClose()
                }
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    className="card iranSansBold"
                    label="آدرس مقصد"
                    onKeyDown={props.onKeyDown}
                    onChange={onTextChange}
                    endAdornment={'sss'}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}

